/* */ 
var createFlow = require('../internal/createFlow');
var flowRight = createFlow(true);
module.exports = flowRight;
